import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

function Intro() {
  const [videoOpen, setVideoOpen] = useState(false);
  const [playing, setPlaying] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    if (!videoOpen) return;
    const onKey = (e) => e.key === 'Escape' && setVideoOpen(false);
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [videoOpen]);

  const items = [
    { icon: 'fas fa-users', label: '+200 clientes atendidos' },
    { icon: 'fas fa-layer-group', label: 'Projetos em diferentes segmentos' },
    { icon: 'fas fa-user-friends', label: 'Equipe multidisciplinar' },
    {
      icon: 'fas fa-bullseye',
      label: 'Atuação estratégica e execução integrada',
    },
  ];

  return (
    <section id="about" className="intro section-padding">
      <div className="container">
        <div className="row lg-marg">
          <div className="col-lg-8 md-mb80">
            <div className="text">
              <h3 className="intro-headline mb-30 wow fadeInUp" style={{ fontSize: 'clamp(1.6rem, 3.5vw, 2.5rem)', lineHeight: 1.2 }}>
                A Hanzol conecta{' '}
                <span className="main-color">estratégia</span>,{' '}
                <span className="main-color">publicidade</span>,{' '}
                <span className="main-color">conteúdo</span> e{' '}
                <span className="main-color">execução</span>{' '}
                dentro da mesma operação.
              </h3>
              <p
                className="wow fadeInUp"
                data-wow-delay="0.2s"
                style={{ fontSize: '1.1rem', lineHeight: 1.7, maxWidth: '720px' }}
              >
                O trabalho envolve planejamento, campanhas, produção de conteúdo,
                tráfego e posicionamento para estruturar o marketing de forma
                contínua dentro do negócio.
              </p>
            </div>

            <div className="numbers mt-60">
              <div className="row lg-marg">
                {items.map((item, idx) => (
                  <div className="col-md-6" key={idx}>
                    <div
                      className="intro-item item bord-thin-top pt-30 d-flex align-items-center mt-20 wow fadeInUp"
                      data-wow-delay={`${0.1 + idx * 0.1}s`}
                    >
                      <div
                        className="icon main-color"
                        style={{ fontSize: '2rem', marginRight: '20px' }}
                      >
                        <i className={item.icon}></i>
                      </div>
                      <div>
                        <h6 className="fw-500" style={{ fontSize: '1.05rem' }}>
                          {item.label}
                        </h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-lg-4 wow fadeInRight" data-wow-delay="0.2s">
            <div
              className="intro-photos"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gridTemplateRows: 'repeat(2, 220px)',
                gap: '14px',
                height: '100%',
              }}
            >
              <div
                className="intro-photo-main"
                style={{
                  gridColumn: 'span 2',
                  borderRadius: '14px',
                  overflow: 'hidden',
                  position: 'relative',
                }}
              >
                <img
                  src="/assets/imgs/intro/FOTO_1.png"
                  alt=""
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <div
                  className="play-overlay"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background:
                      'linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.45) 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <button
                    type="button"
                    onClick={() => setVideoOpen(true)}
                    className="play-arc-btn"
                    aria-label="Assistir vídeo da Hanzol"
                  >
                    <svg
                      className="play-arc-text"
                      viewBox="0 0 200 200"
                      width="170"
                      height="170"
                    >
                      <defs>
                        <path
                          id="play-arc-path"
                          d="M 100,100 m -78,0 a 78,78 0 1,1 156,0 a 78,78 0 1,1 -156,0"
                        />
                      </defs>
                      <text
                        fontSize="11"
                        fill="#fff"
                        style={{ fontWeight: 500, letterSpacing: '2px' }}
                      >
                        <textPath
                          href="#play-arc-path"
                          startOffset="0"
                          textLength="490"
                          lengthAdjust="spacing"
                        >
                          MERGULHE A FUNDO • HANZOL •
                        </textPath>
                      </text>
                    </svg>
                    <span className="play-arc-core">
                      <i className="fas fa-play"></i>
                    </span>
                  </button>
                </div>
              </div>
              <div style={{ borderRadius: '14px', overflow: 'hidden' }}>
                <img
                  src="/assets/imgs/intro/FOTO_2.png"
                  alt=""
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div style={{ borderRadius: '14px', overflow: 'hidden' }}>
                <img
                  src="/assets/imgs/intro/FOTO_3.png"
                  alt=""
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {videoOpen && ReactDOM.createPortal(
        <div
          className="video-modal"
          onClick={() => setVideoOpen(false)}
          role="dialog"
          aria-modal="true"
        >
          <button
            type="button"
            className="video-modal-close"
            onClick={(e) => {
              e.stopPropagation();
              setVideoOpen(false);
            }}
            aria-label="Fechar"
          >
            <i className="fas fa-times"></i>
          </button>
          <div
            className="video-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <video
              ref={videoRef}
              autoPlay
              playsInline
              onPlay={() => setPlaying(true)}
              onPause={() => setPlaying(false)}
              style={{
                width: '100%',
                height: '100%',
                display: 'block',
                background: '#000',
              }}
            >
              <source src="/assets/video/hanzol-intro.mp4" type="video/mp4" />
            </video>
          </div>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              if (!videoRef.current) return;
              playing ? videoRef.current.pause() : videoRef.current.play();
            }}
            style={{
              position: 'fixed',
              bottom: '32px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              background: '#F5C518',
              border: 0,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#000',
              fontSize: '1.2rem',
              zIndex: 10001,
            }}
            aria-label={playing ? 'Pausar' : 'Play'}
          >
            <i className={playing ? 'fas fa-pause' : 'fas fa-play'}></i>
          </button>
        </div>,
        document.body
      )}

      <style>{`
        .play-arc-btn {
          position: relative;
          width: 170px;
          height: 170px;
          background: transparent;
          border: 0;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }
        .play-arc-text {
          position: absolute;
          inset: 0;
          animation: play-arc-spin 14s linear infinite;
          transition: opacity 0.3s ease;
        }
        .play-arc-core {
          position: relative;
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background: #F5C518;
          color: #000;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.1rem;
          padding-left: 4px;
          box-shadow: 0 0 0 0 rgba(245, 197, 24, 0.5);
          transition: transform 0.35s ease, box-shadow 0.35s ease;
          animation: play-arc-pulse 2.4s ease-in-out infinite;
        }
        .play-arc-btn:hover .play-arc-core {
          transform: scale(1.08);
          box-shadow: 0 0 0 14px rgba(245, 197, 24, 0.12);
        }
        .play-arc-btn:hover .play-arc-text {
          animation-duration: 7s;
        }
        @keyframes play-arc-spin {
          to { transform: rotate(360deg); }
        }
        @keyframes play-arc-pulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(245, 197, 24, 0.5); }
          50% { box-shadow: 0 0 0 18px rgba(245, 197, 24, 0); }
        }

        .video-modal {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.85);
          backdrop-filter: blur(6px);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 30px;
          animation: hanzol-fadeIn 0.3s ease;
        }
        .video-modal-content {
          width: 100%;
          max-width: 960px;
          aspect-ratio: 16 / 9;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6);
          position: relative;
        }
        .video-modal-close {
          position: absolute;
          top: 24px;
          right: 24px;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: rgba(255, 255, 255, 0.05);
          color: #fff;
          font-size: 1.1rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }
        .video-modal-close:hover {
          background: #F5C518;
          color: #000;
          border-color: #F5C518;
          transform: rotate(90deg);
        }

        @media (max-width: 768px) {
          .play-arc-btn { width: 140px; height: 140px; }
          .play-arc-text { width: 140px; height: 140px; }
          .play-arc-core { width: 54px; height: 54px; font-size: 1rem; }
          .video-modal { padding: 16px; }
          .video-modal-close { top: 12px; right: 12px; width: 40px; height: 40px; }
        }
      `}</style>
    </section>
  );
}

export default Intro;
